export default "__VITE_ASSET__7123b91c__"